import React, { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import Select, { Option } from "react-select";

const AddItemOption = ({ option, children, innerRef, ...props }) => {
  if (option === addNewItemOption) {
    children = (
      <div className="text-primary">
        <span className="fa fa-plus" /> <Trans>Add new item</Trans>
      </div>
    );
  }

  return (
    <Option {...props} option={option} ref={innerRef}>
      {children}
    </Option>
  );
};

const addNewItemOption = {};

export const AddNewItemSelect = ({
  options: optionsProp,
  onNewItem,
  onChange: onChangeProp,
  ...props
}) => {
  const { t } = useTranslation();
  const options = useMemo(
    () => [addNewItemOption, ...optionsProp],
    [optionsProp, t]
  );

  return (
    <Select
      options={options}
      onChange={(v) => {
        if (v === addNewItemOption) {
          onNewItem();
        } else {
          onChangeProp(v);
        }
      }}
      optionComponent={({ ref, ...props }) => (
        <AddItemOption innerRef={ref} {...props} />
      )}
      {...props}
    />
  );
};
